<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>安卓APK发布管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-tabs v-model="activeAppType"
               @tab-click="onAppTypeTabClick">
        <el-tab-pane label="爱零工"
                     name="1"></el-tab-pane>
        <el-tab-pane label="查理宝"
                     name="2"></el-tab-pane>
      </el-tabs>
      <div class="margin b15">
        <router-link :to="createPath">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">发布
          </el-button>
        </router-link>
      </div>
      <el-table :key="activeAppType"
                :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">

        <el-table-column prop="id"
                         label="ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="title"
                         label="名称"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="vision"
                         label="安卓版本号"
                         width="120"></el-table-column>
        <el-table-column prop="loadurl"
                         label="安卓APK下载链接"
                         min-width="190">
          <template slot-scope="scope">
            <a :href="scope.row.loadurl"
               download="">
              <span>{{scope.row.loadurl}}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="ios_version"
                         label="IOS版本号"
                         width="120"></el-table-column>
        <el-table-column prop="ios_loadurl"
                         label="IOS下载链接"
                         width="190"></el-table-column>
        <el-table-column prop="changelog"
                         label="发布日志"
                         min-width="120"></el-table-column>
        <el-table-column v-if="isAlg"
                         prop="type"
                         label="是否为白名单APK"
                         min-width="90">
          <template slot-scope="scope">
            <span>{{scope.row.type === 1 ? '是' : '不是'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="force_update"
                         label="强制升级"
                         min-width="60">
          <template slot-scope="scope">
            <span>{{scope.row.force_update === 1 ? '是' : '不是'}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isClb"
                         prop="enable_hot_update"
                         label="是否热更新"
                         min-width="90">
          <template slot-scope="scope">
            <span>{{Number(scope.row.enable_hot_update) === 1 ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isClb"
                         prop="force_hot_update"
                         label="是否强制热更新"
                         min-width="110">
          <template slot-scope="scope">
            <span>{{Number(scope.row.force_hot_update) === 1 ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createtime"
                         label="创建时间"
                         min-width="120"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="160">

          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/platform-androidapk-test/update/${scope.row.id}`">
                <el-button size="mini"
                           type="primary">修改
                </el-button>
              </router-link>
              <el-button type="danger"
                         size="mini"
                         @click="onDelete(scope.$index, table)">删除
              </el-button>
            </div>

          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../platform-androidapk-test.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

const APP_TYPE_ALG = '1'
const APP_TYPE_CLB = '2'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
        app_type: APP_TYPE_ALG,
      },
      searchFieldType: {
        app_type: String,
      },
      activeAppType: APP_TYPE_ALG,
    }
  },
  computed: {
    isAlg () {
      return String(this.search.app_type) === APP_TYPE_ALG
    },
    isClb () {
      return String(this.search.app_type) === APP_TYPE_CLB
    },
    createPath () {
      return {
        path: '/platform-androidapk-test/create',
        query: {app_type: String(this.search.app_type || APP_TYPE_ALG)},
      }
    },
    exportHeader () {
      const headers = [
        {key: 'id', text: '序列号ID'},
        {key: 'title', text: '安卓APK名称'},
        {key: 'vision', text: '安卓版本号'},
        {key: 'loadurl', text: '安卓下载链接'},
        {key: 'ios_version', text: 'IOS版本号'},
        {key: 'ios_loadurl', text: 'IOS下载链接'},
        {key: 'changelog', text: '发布日志'},
      ]
      if (this.isAlg) {
        headers.push({
          key: 'type',
          text: '是否为白名单APK',
          formatter: (row) => Number(row.type) === 1 ? '是' : '不是',
        })
      }
      headers.push({
        key: 'force_update',
        text: '强制升级',
        formatter: (row) => Number(row.force_update) === 1 ? '是' : '不是',
      })
      if (this.isClb) {
        headers.push(
          {
            key: 'enable_hot_update',
            text: '是否热更新',
            formatter: (row) => Number(row.enable_hot_update) === 1 ? '是' : '否',
          },
          {
            key: 'force_hot_update',
            text: '是否强制热更新',
            formatter: (row) => Number(row.force_hot_update) === 1 ? '是' : '否',
          }
        )
      }
      headers.push({key: 'createtime', text: '创建时间'})
      return headers
    },
  },
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      const appType = String(
        (params && params.app_type) || this.search.app_type || this.activeAppType || APP_TYPE_ALG
      )
      return request.page('getPlatformAndroidapkTestTable', {
        ...params,
        app_type: appType,
      })
    },
    setSearchParams (params) {
      const next = Object.assign({}, params)
      if (next.app_type === undefined || next.app_type === null || next.app_type === '') {
        next.app_type = APP_TYPE_ALG
      } else {
        next.app_type = String(next.app_type)
      }
      this.activeAppType = next.app_type
      this.search.app_type = next.app_type
      table.methods.setSearchParams.call(this, next)
    },
    onAppTypeTabClick (tab) {
      const appType = String(tab.name)
      if (String(this.search.app_type) === appType) {
        return
      }
      this.search.app_type = appType
      this.activeAppType = appType
      this.pagination.current_page = 1
      this.onSearch()
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportPlatformAndroidapkTestData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deletePlatformAndroidapkTestData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
          this.onSearch()
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/platform-androidapk-test/pages/PlatformAndroidapkTestTable.vue